import Utils from "../../services/Utils.js";
import { getLiveGames } from "../../js/api/inPlay.js";
import { getLiveSports } from "../../js/api/liveSports.js";
import {
  getLiveTemplate,
  getLiveTemplateEvent,
} from "../templates/live-games.js";
import { _t } from "../../services/TranslationService.js";
import { getSearchGames } from "../../js/api/search.js";
import { getSearchingGames } from "../templates/search-games.js";
import { filterBlockedSports } from "../../services/BlockedSports.js";

var mainLeagues = [];
let getSportValueId = 1;
let timers = [];
let market_type = 1;
let clickInProgress = false;

let Games = {
  render: async () => {
    let request = Utils.parseRequestURL();

    let requestedSportId = request.id;

    if (localStorage.getItem("inplay-sportid")) {
      requestedSportId = localStorage.getItem("inplay-sportid");
      localStorage.removeItem("inplay-sportid");
    }

    const sportsInTaps = filterBlockedSports([
      {
        id: 1,
        name: _t("Futboll"),
        icon: '<i class="flex flex-wrap w-[20px] mr-1 h-[20px] sport-soccer"></i>',
      },
      {
        id: 2,
        name: _t("Basketboll"),
        icon: '<i class="flex flex-wrap w-[20px] mr-1 h-[20px] sport-basketball"></i>',
      },
      {
        id: 5,
        name: _t("Tenis"),
        icon: '<i class="flex flex-wrap w-[20px] mr-1 h-[20px] sport-tennis"></i>',
      },
      {
        id: 20,
        name: _t("Ping Pong"),
        icon: '<i class="flex flex-wrap w-[20px] mr-1 h-[20px] sport-table-tennis"></i>',
      },
    ]);

    const requestedSport = sportsInTaps.find(
      (sport) => String(sport.id) === String(requestedSportId)
    );
    getSportValueId = requestedSport
      ? String(requestedSport.id)
      : sportsInTaps[0]
      ? String(sportsInTaps[0].id)
      : "";

    let games = getSportValueId ? await renderGames(true) : "";

    let view = /*html*/ `
        <div id="gamesLeagueWrapper">
            <div class="w-full flex flex-row flex-wrap">
                <div class="flex flex-row flex-wrap w-full bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] w-full items-center content-center shadow-[3px_3px_3px_#000000]">
                    <div class="in-play-header-tabs flex flex-wrap w-full flex-row bg-black/60">
                        ${sportsInTaps
                          .map((sport, i) => {
                            return `
                                <a href="#" class="
                                    in-play-header-tab
                                    border-r 
                                    flex 
                                    flex-row 
                                    flex-wrap 
                                    text-white font-[400] 
                                    text-[12px] 
                                    leading-[25px] 
                                    cursor-pointer 
                                    h-[25px] 
                                    font-sans 
                                    space-x-1 
                                    px-2 
                                    items-center 
                                    border-[#3d3d3d] ${
                                      String(sport.id) ===
                                      String(getSportValueId)
                                        ? "active bg-[#81011e] pointer-events-none"
                                        : "hover:bg-[#8d741d]"
                                    }" 
                                    sportid="${sport.id}">${sport.icon} ${
                              sport.name
                            }
                                </a>
                            `;
                          })
                          .join("")}
                    </div>
                </div>
                <div id="inPlayMainContentHolder" class="flex flex-wrap flex-row w-full">
                    ${games}
                </div>
            </div>
            </div>
        `;
    return view;
  },
  after_render: async (socket) => {
    localStorage.setItem("matchSport", 0);
    // $("body").on("keyup", "#findGame", function (e) {
    //   e.preventDefault();

    //   // Debounce
    //   if (window.searchTimeout) clearTimeout(window.searchTimeout);

    //   window.searchTimeout = setTimeout(() => {
    //     const searchText = $(this).val().toLowerCase();

    //     $("body .bettingBtn").each(function () {
    //       const $btn = $(this);
    //       const homeTeam = $btn.attr("match-home-name")?.toLowerCase() || "";
    //       const awayTeam = $btn.attr("match-away-name")?.toLowerCase() || "";
    //       const market = $btn.attr("match-market")?.toLowerCase() || "";

    //       if (
    //         homeTeam.includes(searchText) ||
    //         awayTeam.includes(searchText) ||
    //         market.includes(searchText)
    //       ) {
    //         $btn.parent().css("display", "flex");
    //       } else {
    //         $btn.parent().css("display", "none");
    //       }
    //     });

    //     $("body .bettingBtn").each(function () {
    //       const $parent = $(this).parent();
    //       const $grandparent = $parent.parent();
    //       const $greatGrandparent = $grandparent.parent();

    //       if (!$grandparent.length || !$greatGrandparent.length) return;

    //       const allSiblingsHidden =
    //         $grandparent
    //           .children()
    //           .filter((_, el) => $(el).css("display") !== "none").length === 0;

    //       if (allSiblingsHidden) {
    //         $greatGrandparent.css("display", "none");
    //       } else {
    //         $greatGrandparent.css("display", "flex");
    //       }
    //     });
    //   }, 300);
    // });

    socket.emit("connectToRoom", { room: "inplay" });
    fix();
    socket.on("new-live-game", (data) => {
      if (data.sport_id == getSportValueId) {
        const liveGame = document.getElementById(data.id);

        if (!liveGame) {
          const liveGameContainer = document.getElementById("pre-match-games");
          const leagueId = mainLeagues.find((a) => a.name == data.league);
          if (leagueId) {
            const leagueContent = document.getElementsByClassName(
              leagueId.leagueId
            );
            const template = getLiveTemplateEvent(data);
            if (leagueContent && leagueContent[0]) {
              if (liveGameContainer) {
                leagueContent[0].innerHTML += template;
              }
            } else {
              if (liveGameContainer) {
                liveGameContainer.innerHTML += `
                                    <div class="gameTableContent ${leagueId} flex flex-wrap flex-row w-full">
                                        <div class="singleGameDateLabel flex flex-wrap flex-row w-full text-[11px] leading-[19px] font-normal text-left text-[white] bg-black/70 items-center mb-[1px] space-x-1 py-1 border-b border-[#6f6c6c]">
                                            <span class="h-[14px] w-[14px] overflow-hidden m-1" style="background-repeat: no-repeat; background-image: url('./img/flags.svg'); background-size: 532px 56px;"></span>
                                            <span class="titleMarketSearch flex flex-wrap flex-row pt-[1px]">${leagueName}</span>
                                        </div>
                                        <div class="contentSingleGameHolder flex flex-wrap flex-row w-full" id="pre-match-games">
                                            ${template}
                                        </div>
                                    </div>
                                `;
              }
            }

            const check = timers.find((a) => a.game_id == data.id);
            if (!check) {
              const timerId = setInterval(
                () => liveTimer(`${data.id}-timer`),
                1000
              );
              timers.push({ game_id: data.id, timerId });
            }
          }
        } else {
          const newTemplate = getLiveTemplateEvent(data);
          if (newTemplate) liveGame.innerHTML = newTemplate;
        }

        fix();
      }
    });

    $(".in-play-header-tabs .in-play-header-tab").unbind("click");
    $(".in-play-header-tabs .in-play-header-tab").on(
      "click",
      async function (e) {
        e.preventDefault();

        const sportId = $(e.currentTarget).attr("sportid");

        $(".in-play-header-tabs .in-play-header-tab.active").removeClass(
          "active bg-[#81011e] pointer-events-none"
        );
        $(
          `.in-play-header-tabs .in-play-header-tab[sportid=${sportId}]`
        ).addClass("active bg-[#81011e] pointer-events-none");

        getSportValueId = sportId;
        const view = await renderGames();
        document.getElementById("inPlayMainContentHolder").innerHTML = view;

        themeChange(sportId);

        if (getSportValueId == 1 || !getSportValueId) {
          if (market_type == 3) {
            $("body").addClass("goalAnotherType");
          }
          renderCoefs();
        } else {
          $("body").removeClass("goalAnotherType");
        }
        bindDropdown();
      }
    );

    $("body").on("click", ".betModuleSportBtn", async function (e) {
      if (clickInProgress === true) return;

      clickInProgress = true;
      const sportId = $(e.currentTarget).attr("sportid");
      if ($(e.currentTarget).hasClass("active")) {
        getSportValueId = sportId;

        const view = await renderGames();
        document.getElementById("inPlayMainContentHolder").innerHTML = view;
      }

      clearTimers();
      themeChange(sportId);

      if (getSportValueId == 1 || !getSportValueId) {
        if (market_type == 3) $("body").addClass("goalAnotherType");
        renderCoefs();
      } else {
        $("body").removeClass("goalAnotherType");
      }
      clickInProgress = false;
    });

    $("body .menuItem a").removeClass("active");
    $("body .mainLeftMenuItem a").removeClass("active");
    $("body #inPlayPage").addClass("active");
    $("body .leftMenuInPlay").addClass("active");

    renderCoefs();
    bindDropdown();

    themeChange(getSportValueId ?? 1);
    $("body #inPlayPage").on("click", function () {
      if (location.hash === "#/InPlay") {
        location.reload();
      }
    });

    let sportId = $("#inPlayMainContentHolder").attr("sportid");

    if (sportId && !isNaN(sportId)) {
      $(".in-play-header-tab.active").removeClass("active");
      $('.in-play-header-tab[sportid="' + sportId + '"]').addClass("active");
    }
  },
  on_unload: async (socket) => {
    socket.emit("leaveRoom", { room: "inplay" });
    clearTimers();
  },
};

function renderCoefs() {
  if (market_type == 3) {
    $(".singleGameDateLabelFirst").text(_t("Lart"));
    $(".singleGameDateLabelSecond").text(_t("Poshtë"));
    $(".singleGameDateLabelThird").text("");

    $(".singleGameDateLabelFirst").removeClass("threeCoefs");
    $(".singleGameDateLabelFirst").addClass("twoCoefs");
    $(".singleGameDateLabelSecond").removeClass("threeCoefs");
    $(".singleGameDateLabelSecond").addClass("twoCoefs");
    $(".singleGameDateLabelThird").width("0");

    $(".singleHomeOdd").removeClass("threeCoefs");
    $(".singleHomeOdd").addClass("twoCoefs");
    $(".singleDrawOdd").removeClass("threeCoefs");
    $(".singleDrawOdd").addClass("twoCoefs");
    $(".singleAwayOdd").width("0");
  } else {
    $(".singleGameDateLabelFirst").text("1");
    $(".singleGameDateLabelSecond").text("X");
    $(".singleGameDateLabelThird").text("2");

    $(".singleGameDateLabelFirst").removeClass("twoCoefs");
    $(".singleGameDateLabelFirst").addClass("threeCoefs");
    $(".singleGameDateLabelSecond").removeClass("twoCoefs");
    $(".singleGameDateLabelSecond").addClass("threeCoefs");
    $(".singleGameDateLabelThird").removeClass("twoCoefs");
    $(".singleGameDateLabelThird").addClass("threeCoefs");

    $(".singleHomeOdd").removeClass("twoCoefs");
    $(".singleHomeOdd").addClass("threeCoefs");
    $(".singleDrawOdd").removeClass("twoCoefs");
    $(".singleDrawOdd").addClass("threeCoefs");
    $(".singleAwayOdd").removeClass("twoCoefs");
    $(".singleAwayOdd").addClass("threeCoefs");
  }
}

function themeChange(sportId) {
  //   console.log('Change Theme: ', sportId);
  $("#inPlayMainContentHolder").attr("sportid", sportId);
  if (sportId == 0) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").removeClass("p-bg");
    $("body #pre-match-games").removeClass("twoColumn");
  }
  if (sportId == 1) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").removeClass("p-bg");
    $("body #pre-match-games").removeClass("twoColumn");
  }
  if (sportId == 2) {
    $("body .betModuleHeaderContainer").removeClass("p-bg");
    $("body .betModuleHeaderContainer").addClass("o-bg");
    $("body #pre-match-games").addClass("twoColumn");
    $(".singleGameDateLabelFirst").removeClass("threeCoefs");
    $(".singleGameDateLabelSecond").removeClass("threeCoefs");
    $(".singleGameDateLabelThird").removeClass("threeCoefs");
  }
  // Tennis
  if (sportId == 5) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").addClass("p-bg");
    $("body #pre-match-games").addClass("twoColumn");
    $(".singleGameDateLabelFirst").removeClass("threeCoefs");
    $(".singleGameDateLabelSecond").removeClass("threeCoefs");
    $(".singleGameDateLabelThird").removeClass("threeCoefs");
  }
  // Table Tennis
  if (sportId == 20) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").addClass("b-bg");
    $("body #pre-match-games").addClass("twoColumn");
    $(".singleGameDateLabelFirst").removeClass("threeCoefs");
    $(".singleGameDateLabelSecond").removeClass("threeCoefs");
    $(".singleGameDateLabelThird").removeClass("threeCoefs");
  }

  if (sportId) {
    setTimeout(() => {
      if (
        $('.betModuleSportBtn[sportid="' + sportId + '"]').hasClass("active")
      ) {
        $("body .betModuleSportBtn").removeClass("current");
        $('.betModuleSportBtn[sportid="' + sportId + '"]').addClass("current");
      }
    }, 300);
  }
}

function liveTimer(id) {
  const current_minute = $(`#${id}`).text();
  if (!current_minute || current_minute == "" || current_minute == "45:00")
    return;
  let minutes = parseInt(current_minute.split(":")[0]);
  let seconds = parseInt(current_minute.split(":")[1]);

  if (seconds == 59) {
    minutes += 1;
    seconds = 0;
  } else seconds += 1;

  $(`#${id}`).text(
    `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`
  );
}

async function renderGames(firstTime = false) {
  let games = await getLiveGames(getSportValueId, market_type);
  const uniqueLeagues = [...new Set(games.map((item) => item.league_id))];

  let gamesView = "";

  uniqueLeagues.forEach((leagueId) => {
    let singleDateView = "";
    let leagueName = "";

    games
      .filter((a) => a.league_id === leagueId)
      .map((game) => {
        if (!game.odd || game.id == 372481) {
          return;
        }

        leagueName = game.league;
        singleDateView += getLiveTemplate(
          game,
          getSportValueId && getSportValueId != 1 ? 1 : market_type
        );

        if (game.sport_id != 5) {
          const check = timers.find((a) => a.game_id == game.id);
          if (!check) {
            const timerId = setInterval(
              () => liveTimer(`${game.id}-timer`),
              1000
            );
            timers.push({ game_id: game.id, timerId });
          }
        }
      });
    gamesView += `
            <div class="gameTableContent flex flex-wrap flex-row w-full ${leagueId}">
                <div class="singleGameDateLabel flex flex-wrap flex-row w-full text-[11px] leading-[19px] font-normal text-left text-[white] bg-black/70 items-center mb-[1px] space-x-1 py-1 border-b border-[#6f6c6c]">
                    <span class="h-[14px] w-[14px] overflow-hidden m-1" style="background-repeat: no-repeat; background-image: url('./img/flags.svg'); background-size: 532px 56px;"></span>
                    <span class="titleMarketSearch flex flex-wrap flex-row pt-[1px]">${leagueName}</span>
                </div>
                <div class="contentSingleGameHolder flex flex-wrap flex-row w-full" id="pre-match-games">
                    ${singleDateView}
                </div>
            </div>
        `;
    mainLeagues.push({
      leagueId: leagueId,
      name: leagueName,
    });
  });

  if (gamesView === "") {
    gamesView = "";
  }

  // let posts = await getPostsList()
  let view = /*html*/ `
      <div class="betModule liveInModule flex flex-wrap w-full flex-row w-full">
            <div class="flex items-center justify-between bg-black/40 w-full flex-row flex-wrap p-1">
                <div class="betModuleHeaderBtn flex flex-wrap flex-row relative">
                    <div class="flex topHolder">
                        <div class="searchHolder w-full relative">
                            <div class="searchHeader relative">
                                <div class="relative w-full flex flex-wrap flex-row w-full">
                                    <img class="w-[14px] h-[14px] absolute left-1 top-[50%] -translate-y-1/2 pointer-none" src="~/../img/search.png" />
                                    <input type="text" id="findGame" class="searchInputLabel1 bg-[rgba(255,255,255,0.2)] border border-[rgba(255,255,255,0.4)] text-white h-[20px] text-[12px] pl-5" />

                                    <div class="helper1 absolute right-0 top-0 cursor-pointer w-[40px] h-[20px] z-10 hidden flex-wrap flex-row spasce-x-2 justify-between">
                                        <div class="closeSearch flex items-center w-[20px] h-[20px]">
                                            <span class="text-white text-[14px] w-[20px] leading-[20px] text-center font-bold">x</span>
                                        </div>
                                        <div class="closeSearch w-[20px] h-[20px]">
                                            <svg class="w-full h-full fill-white" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="icon" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                                                <path d="M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8  l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"/>
                                                <rect id="_x3C_Transparent_Rectangle_x3E__589_" class="st0" width="32" height="32"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="searchContent1 absolute w-auto left-0 top-[25px] bg-white z-10 h-auto max-h-[calc(100vh-178px)] overflow-y-scroll ease-in-out duration-100" id="searchContent1"></div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row flex-wrap">
                    <a class="
                        border-r 
                        flex 
                        flex-row 
                        flex-wrap 
                        text-white font-[400] 
                        text-[12px] 
                        leading-[25px] 
                        cursor-pointer 
                        h-[25px] 
                        font-sans 
                        space-x-1 
                        px-2 
                        items-center
                        dropdownItemLinks 
                        ${
                          market_type == 1
                            ? "active bg-[#8d741d] pointer-events-none"
                            : ""
                        }
                    " 
                    data-id="1">
                        ${_t("Rezultat Final")}
                    </a>
                    <a class="
                        border-r 
                        flex 
                        flex-row 
                        flex-wrap 
                        text-white font-[400] 
                        text-[12px] 
                        leading-[25px] 
                        cursor-pointer 
                        h-[25px] 
                        font-sans 
                        space-x-1 
                        px-2 
                        items-center
                        dropdownItemLinks 
                        ${
                          market_type == 2
                            ? "active bg-[#8d741d] pointer-events-none"
                            : ""
                        }
                    " 
                    data-id="2">
                        ${_t("Goli i rradhes")}
                    </a>
                    <a class="
                        flex 
                        flex-row 
                        flex-wrap 
                        text-white font-[400] 
                        text-[12px] 
                        leading-[25px] 
                        cursor-pointer 
                        h-[25px] 
                        font-sans 
                        space-x-1 
                        px-2 
                        items-center
                        dropdownItemLinks
                        ${
                          market_type == 3
                            ? "active bg-[#8d741d] pointer-events-none"
                            : ""
                        }
                    " 
                    data-id="3">
                        ${_t("Golat")}
                    </a>
                </div>
            </div>
        </div>
        <div class="betModuleTabs flex flex-row flex-wrap w-full bg-black/40 ">
            <div class="betModuleTabsBtn flex flex-row flex-wrap w-full">
                <div id="pre-match-games" class="flex flex-row flex-wrap w-full ">
                    ${gamesView}
                </div>
            </div>
        </div>
    `;
  fix();
  return view;
}

function fix() {
  $(document)
    .off("click.topHolder.searchclose", ".closeSearch")
    .on("click.topHolder.searchclose", ".closeSearch", function () {
      $("body .searchInputLabel1").val("");
      $("body .searchInputLabel1").blur();
      $("body #searchContent1").html("");
      $("body .helper1").removeClass("flex");
      $("body .helper1").addClass("hidden");
    });
  setTimeout(() => {
    let searchTimeout;
    const findGameInput = document.getElementById("findGame");
    
    findGameInput.addEventListener("keyup", () => {
      clearTimeout(searchTimeout); // Clear previous timeout to debounce

      const bettingButtons = document.querySelectorAll(".bettingBtn");

      searchTimeout = setTimeout(async () => {
        const $input = $("body .searchInputLabel1").val();

        const $content = $("body #searchContent1");
        const $helper = $("body .helper1");

        // Reset when empty
        if ($input.length === 0) {
          $input.val("").focus();
          $helper.removeClass("flex").addClass("hidden");
          return;
        }

        // Only search when 3+ chars
        if ($input.length < 2) return;

        try {
          const searchValues = await getSearchGames($input);

          if (!Array.isArray(searchValues) || searchValues.length === 0) {
            // No results
            $content.html(``);
            $helper.removeClass("flex").addClass("hidden");
            return;
          }

          // Get unique, sorted YYYY-MM-DD dates (lexicographic works for ISO)
          const uniqueDates = [
            ...new Set(searchValues.map((i) => i.game_date)),
          ].sort();

          let searchGamesView = "";

          uniqueDates.forEach((date) => {
            let singleDateView = "";

            const currentUrlIsLive = window.location.hash; // Get current hash URL
            const base = searchValues
              // skip invalid/excluded
              .filter((a) => a?.odd && a.id !== 372481 && a?.type_id != null); // require type_id

            if (
              currentUrlIsLive.startsWith("#/livematch/") ||
              currentUrlIsLive.startsWith("#/inplay")
            ) {
              // LIVE/INPLAY: only type_id === 1
              base
                .filter((a) => Number(a.type_id) !== 1)
                .forEach((a) => {
                  // place into the correct date section (no up-front date filter)
                  if (a.game_date !== date) return;
                  singleDateView += getSearchingGames(a, a.type_id); // fixed typo
                });
            } else {
              // NON-LIVE: everything except type_id === 1
              base
                .filter((a) => Number(a.type_id) === 1)
                .forEach((a) => {
                  if (a.game_date !== date) return;
                  singleDateView += getSearchingGames(a, a.type_id);
                });
            }

            if (singleDateView) {
              searchGamesView += `
                  <div class="searchLabelGroup flex flex-wrap flex-row w-full">
                    <div class="search-games w-full space-y-2">
                      <ul>${singleDateView}</ul>
                    </div>
                  </div>
                `;
            }
          });

          // If all items were filtered out, show "no results"
          if (!searchGamesView) {
            $content.html(`
                            <div class="p-3 text-sm text-white/80 bg-black/40">Nuk gjetem rezultat.</div>
                        `);
          } else {
            $content.html(searchGamesView);
          }

          // Open panel
          $helper.removeClass("hidden").addClass("flex");
        } catch (err) {
          console.error("Search error:", err);
          $content.html(`
                      <div class="p-3 text-sm text-red-300 bg-black/40">
                        Something went wrong while searching. Please try again.
                      </div>
                    `);
          $helper.removeClass("hidden").addClass("flex");
        }
      }, 300);
    });
  }, 100);
}

function clearTimers() {
  if (!timers || (timers && timers.length === 0)) return;

  for (let i = 0; i < timers.length; i++) {
    const timer = timers[i];
    clearInterval(timer.timerId);
  }
}

function bindDropdown() {
  $("body .dropdownSelectedLabel").unbind("click");
  $("body .dropdownSelectedLabel").on("click", function (e) {
    let dropdownItem = $(e.currentTarget)
      .siblings(".dropdownContentItem")
      .children(".dropdownItemLinks").length;

    if ($(this).parent().hasClass("expand")) {
      $(e.currentTarget).parent().removeClass("expand");
      $(e.currentTarget)
        .siblings(".dropdownContentItem")
        .css({
          height: 0 + "px",
        });
    } else {
      $(e.currentTarget).parent().addClass("expand");
      $(e.currentTarget)
        .siblings(".dropdownContentItem")
        .css({
          height: dropdownItem * 40 + "px",
        });
    }
  });

  $("body .dropdownItemLinks").unbind("click");
  $("body .dropdownItemLinks").on("click", async function (e) {
    let getLabelValue = $(this).text();
    let getSelectValue = $(this).attr("data-id");

    if (getSelectValue == 3) {
      $("body").addClass("goalAnotherType");
    } else {
      $("body").removeClass("goalAnotherType");
    }

    $(".dropdownItemLinks").removeClass("active");
    $(e.currentTarget).addClass("active");

    $(".dropdownSelectedLabel").text(getLabelValue);

    market_type = getSelectValue;
    const view = await renderGames(false);
    document.getElementById("inPlayMainContentHolder").innerHTML = view;

    $(".dropdownSelectedLabel").parent().removeClass("expand");
    $(".dropdownSelectedLabel")
      .siblings(".dropdownContentItem")
      .css({
        height: 0 + "px",
      });

    renderCoefs();
    bindDropdown();
  });
}
export default Games;
